var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 11.3333V14.1667C14.1665 14.5424 14.0172 14.9027 13.7516 15.1684C13.4859 15.4341 13.1256 15.5833 12.7498 15.5833H2.83317C2.45745 15.5833 2.09711 15.4341 1.83144 15.1684C1.56576 14.9027 1.4165 14.5424 1.4165 14.1667V4.25001C1.4165 3.87429 1.56576 3.51395 1.83144 3.24828C2.09711 2.9826 2.45745 2.83334 2.83317 2.83334H5.6665",
    stroke: "#8EB4C3",
    strokeOpacity: 1,
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.854 11.1917L15.5832 4.39167L12.6082 1.41667L5.879 8.14584L5.6665 11.3333L8.854 11.1917Z",
    stroke: "#8EB4C3",
    strokeOpacity: 1,
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.24bf31a8d8ea8d49e25438eaf71b93a9.svg";
export { ForwardRef as ReactComponent };